import Phaser from "phaser";
export default class Tutorial extends Phaser.Scene {
    constructor() {
        super('tutorial-scene')
    }
    init() {
        this.back = undefined
    }
    preload() {
        this.load.image('Background', 'images/Tutorial-Screen.jpg')
        this.load.image('Icon', 'images/Icon.png')
        this.load.image('Back', 'images/back-btn.png')
    }
    create() {
        const gameWidth = this.scale.width*0.5
        const gameHeight = this.scale.height*0.5
        this.add.image(gameWidth, gameHeight, 'Background')
        this.add.image(gameWidth, gameHeight-300, 'Icon')
        this.back = this.add.image(100, 900, 'Back')
        .setScale(3)
        .setInteractive()
        this.back.once('pointerup', () => {
            this.scene.start('home-screen-scene')
        })
        this.add.text(50, 400,
        'Press up/down/left/right arrow to move character', {fontSize: '40px', fontStyle: 'Bold', color: 'black'})
        this.add.text(50, 445,
        'Press left shift to slow down', {fontSize: '40px', fontStyle: 'Bold', color: 'black'})
        this.add.text(50, 490,
        'Press Space bar to shoot the enemy', {fontSize: '40px', fontStyle: 'bold', color: 'black'})
    }
}
